import React, { useEffect, useState } from 'react'
import { Breadcrumbs } from '@/components/ui/breadcrumb'
import { MyTicketsViewType } from 'api/Tickets/Types/MyTicketsViewType'
import { getTicketFields } from 'components/Filter/TicketFields'
import { useAppDispatch, useAppSelector } from 'store'
import { getMyTicketViewTypesAction } from 'store/tickets/tickets.actions'
import { useApiClient } from 'utils/api/ApiClient'
import { TicketsApiClient } from 'utils/api/ticketsApi'
import { links } from 'utils/featureToggles'
import { isEmpty } from 'utils/is-empty'

import myTicketsColumn from './myTicketsColumn'
import MyTicketsTypeSelect from './MyTicketsTypeSelect'
import Tickets from './Tickets/Tickets'
import { TicketsViewType } from './TicketsViewType'

const useMapStateToProps = () => ({
  myTicketViewTypes: useAppSelector((state) => state.tickets.myTicketViewTypes),
})

const useMapDispatchToProps = () => {
  const dispatch = useAppDispatch()

  const ticketsApiClient = useApiClient(TicketsApiClient)

  return {
    fetchMyTicketViewTypes: () => dispatch(getMyTicketViewTypesAction(ticketsApiClient)),
  }
}

const TicketsMyTickets = (): JSX.Element => {
  const { myTicketViewTypes } = useMapStateToProps()
  const { fetchMyTicketViewTypes } = useMapDispatchToProps()

  const [myTicketsType, setMyTicketsType] = useState(MyTicketsViewType.All)

  useEffect(() => {
    if (isEmpty(myTicketViewTypes)) {
      fetchMyTicketViewTypes()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleMyTicketsTypeChange = (ticketsType: number) => {
    setMyTicketsType(ticketsType)
  }

  return (
    <React.Fragment>
      <Breadcrumbs crumbs={[{ title: 'My Tickets', link: links.ticketsMyTickets.url }]} />
      <MyTicketsTypeSelect
        myTicketsTypes={myTicketViewTypes}
        myTicketType={myTicketsType}
        onTicketsTypeChange={handleMyTicketsTypeChange}
      />
      <Tickets
        viewType={TicketsViewType.MyTickets}
        columns={myTicketsColumn}
        filterFields={getTicketFields}
        myTicketsType={myTicketsType}
      />
    </React.Fragment>
  )
}

export default TicketsMyTickets
